export const DEFAULT_MAX_LENGTH_TEXT_AREA = 1024;